// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_list-module__container--2vEzU","item":"notification_list-module__item--h3teB","empty":"notification_list-module__empty--1Wii1"};